<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <!-- <PageTitle title="Bank Account" subtitle="Verify Deposit" /> -->
        <div class="auth-header">
            <div class="auth-heading">
                <h1>Bank Account</h1>
                <p class="auth-subtext">Verify Deposit</p>
            </div>
            <div class="brand-icon">
                <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
            </div>
        </div>
        <div class="form_text">
          <div class="text bank_account_body_wrapper">
            You will receive a microdeposit in the provided bank account from Locumate in 1-3 business days. Please confirm the amount received and enter in the amount below in order to be eligible to receive Pay Next Day payment.
          </div>
          <div>
            <h4 class="sub_title">Account Name</h4>
            <p>
              {{ billing.bankAccountName }}
            </p>
            <h4 class="sub_title">BSB</h4>
            <p>{{ bsbHiddenText }}</p>
            <h4 class="sub_title">Account Number</h4>
            <p>
              {{ accountNumberHiddenText }}
            </p>
          </div>
          <div class="deposite">
            <p>Enter the deposit amount below</p>
            <el-form :model="formsData.userForm" :rules="formsData.userForm.rules"
              :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="save('userForm')"
              @keyup.enter="save('userForm')">
              <el-form-item  label="Deposit Amount" prop="depositAmount" :required="true">
                
                <div class="el-input el-input--suffix deposit__amount--outer">
                  <el-input class="input_currency deposit__amount" v-model="formsData.userForm.depositAmount.value" :precision="2" :step="0.1" :max="50" :min="0"
                    :controls="false" :placeholder="'0.00'" @change="checkFormValidation('userForm', true, 'depositAmount')"
                    @blur="checkFormValidation('userForm', true, 'depositAmount')" @keyup="validateFormat($event.target.value)"></el-input>
                    <span class="el-input__suffix" v-if="isAustralia">AUD</span>
                    <span class="el-input__suffix" v-else>USD</span>
                </div>
              </el-form-item>

              <el-form-item class="button_submit mb0">
                <el-button class="submit" type="blue" @click="save('userForm')" :disabled="formsData.userForm.disabled">
                  Verify
                </el-button>
              </el-form-item>
            </el-form>
            <div class="bg-overlay"></div>
          </div>
        </div>
        <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  onMounted,
  computed,
  inject
  // reactive,
} from "vue";
import { ElMessageBox } from 'element-plus';
import { addIcons } from "ionicons";
import { arrowBackOutline, downloadOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
  "download-outline": downloadOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
} from "@ionic/vue";

import { useRouter } from "vue-router";
import { useStore } from "vuex";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
// import PageTitle from "@/components/PageTitle/PageTitle.vue";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const goBack = () => {
      $router.push({
        name: "profile",
      });
    };
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const billing = userData.billing;
    const setPageClassGlobal = inject("setPageClassGlobal");
    const isAustralia = isAustraliaRegion();

    const bsbHiddenText = computed(() => {
      let hideNumBsb = [];
      for (let i = 0; i < billing.bankBsb.length; i++) {
        if (i < billing.bankBsb.length - 3) {
          hideNumBsb.push("X");
        } else {
          hideNumBsb.push(billing.bankBsb[i]);
        }
      }
      const join = hideNumBsb.join("");

      return join.substr(0, 3) + "-" + join.substr(3);
    });

    const accountNumberHiddenText = computed(() => {
      let hideAccountNum = [];
      for (let i = 0; i < billing.bankAccountNumber.length; i++) {
        if (i < billing.bankAccountNumber.length - 3) {
          hideAccountNum.push("X");
        } else {
          hideAccountNum.push(billing.bankAccountNumber[i]);
        }
      }
      return hideAccountNum.join("");
    });
    const formsDataArray = {
      userForm: {
        depositAmount: {
          value: "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "depositAmount",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    const save = (formName) => {
      console.log("formname", formsRefs[formName].value);
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              // checkFormChanged("userForm", true);
              await $store.dispatch(
                "VERIFY_BENEFICIARY_PAYMENT",
                getFormValues(formName)
              );
              ElMessageBox.alert('Bank Verification completed sucessfully', 'Congratulation', {
                showCancelButton: false,
                showClose: false,
                confirmButtonText: 'OK',

              }).then(() => {
                $router.push({
                  name: "profile",
                });
              })

            } catch (error) {
              console.log("error submit!!");
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };
    onMounted(() => {
     
      setFormRefs();
      setPageClassGlobal("global_verify_deposit_page");
      checkFormValidation('userForm', false);
      // checkFormValidation("userForm", true);
    });

  
    const validateFormat = (value) => {
      // Regular expression to match X.XX format
      // const regex = /^(49(\.00?)?|\d{1,2}(\.\d{1,2})?)$/;
      const regex = /^(49(\.00?)?|\d{1,2}(\.\d{0,2})?)$/;
      // Check if the entered value matches the desired format and is less than 1
      if (!regex.test(value)) {
        // If the format is invalid, remove the last character
        formsData.userForm.depositAmount.value = value.slice(0, -1);
      }
    };

    const {
      checkFormValidation,
      setFormValidation, // eslint-disable-line no-unused-vars
      setFormRefs,
      getFormValues,
      // checkFormChanged,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);
    return {
      goBack,
      formsData,
      checkFormValidation,
      save,
      billing,
      userData,
      userRole,
      bsbHiddenText,
      accountNumberHiddenText,
      validateFormat,
      isAustralia
    };
  },
};
</script>